import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from '@/router'
import store from './store/store'
import i18n from './i18n'
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  let language = to.params.lang
  if(!language){
    language = 'bm'
  }
  i18n.locale = language
  next()
})
new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
